export default __webpack_public_path__ + "a2ea208c13fceaef491d9ad4ea3a48ec.png";